import {NgModule} from '@angular/core';
import {
    ApAgentPlannerDashboardOverviewComponent
} from "./page/ap-agent-planner-dashboard-overview/ap-agent-planner-dashboard-overview.component";
import {
    ApAgentActivityPlannerComponent
} from "./component/protected-components/ap-agent-activity-planner/ap-agent-activity-planner.component";
import {
    ApActivityListComponent
} from "./component/protected-components/ap-activity-list-component/ap-activity-list.component";
import {ApConfigPage} from "./page/config/ap-config.page";
import {
    ApConsultantInfoComponent
} from "./component/protected-components/ap-consultant-info-component/ap-consultant-info.component";
import {ApToolPanelComponent} from "./component/protected-components/ap-tool-panel/ap-tool-panel.component";
import {
    ApToolPanelBarComponent
} from "./component/protected-components/ap-tool-panel/components/ap-tool-panel-bar/ap-tool-panel-bar.component";
import {CrModule} from "../../feature-crm/cr/cr.module";
import {PcModule} from "../../feature-crm/pc/pc.module";

import {NsModule} from "../../feature-core/ns/ns.module";
import {
    AppointmentCardComponent
} from "./component/protected-components/ap-tool-panel/components/ap-appointment-activity/appointment-card-component/appointment-card.component";
import {
    ApAppointmentActivityComponent
} from "./component/protected-components/ap-tool-panel/components/ap-appointment-activity/ap-appointment-activity.component";
import {AsModule} from "../../feature-crm/as/as.module";
import {
    ApAppointmentActivityFormsComponent
} from "./component/protected-components/ap-tool-panel/components/ap-appointment-activity/ap-apponitment-activity-forms/ap-appointment-activity-forms.component";
import {
    ApActivityFormComponent
} from "./component/protected-components/ap-tool-panel/components/ap-appointment-activity/ap-apponitment-activity-forms/ap-activity-form/ap-activity-form.component";
import {
    ApAppointmentBookingComponent
} from "./component/protected-components/ap-tool-panel/components/ap-appointment-activity/ap-apponitment-activity-forms/ap-appointment-booking/ap-appointment-booking.component";
import {
    ApPlanningDetailComponent
} from "./component/protected-components/ap-planning-detail/ap-planning-detail.component";
import {AP_TEST_PROVIDERS} from "./test/ap-test-definition";
import {AP_ENTITY_PROVIDER} from "./ap.entity-provider";
import {CoreModule} from "../../core/core.module";
import {FeaturePlanningRoutingModule} from "../feature-planning.routing.module";
import {PMessagesComponent} from "../../core/shared/p-messages/p-messages.component";


@NgModule({
    declarations: [
        ApAgentPlannerDashboardOverviewComponent,
        ApAgentActivityPlannerComponent,
        ApActivityListComponent,
        ApConfigPage,
        ApConsultantInfoComponent,
        ApToolPanelComponent,
        ApToolPanelBarComponent,
        ApAppointmentBookingComponent,
        AppointmentCardComponent,
        ApAppointmentActivityComponent,
        ApAppointmentActivityFormsComponent,
        ApActivityFormComponent,
        ApPlanningDetailComponent
    ],
    exports: [
        ApActivityListComponent,
    ],
    imports: [
        CoreModule,
        CrModule,
        PcModule,
        NsModule,
        AsModule,
        FeaturePlanningRoutingModule,
        PMessagesComponent
    ],
    providers: [
        AP_TEST_PROVIDERS,
        AP_ENTITY_PROVIDER,
    ]
})
export class ApModule { }
